import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Inscription } from '../interfaces/inscription';

@Injectable({
  providedIn: 'root'
})
export class InscriptionService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/inscriptions/'
  }
  getListInscriptions(): Observable<Inscription[]> {
      return this.http.get<Inscription[]>(`${this.myAppUrl}${this.myApiUrl}`);
      
     }
   
     deleteInscription(id: number): Observable<void> {
      console.log("id en service: "+id);
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveInscription(inscription: Inscription): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,inscription)
     }
   
     getInscription(id: number): Observable<Inscription> {
       return this.http.get<Inscription>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }

     getInscriptionByStudentId(idstudent: number): Observable<Inscription> {
       return this.http.get<Inscription>(`${this.myAppUrl}${this.myApiUrl}student/${idstudent}`);
     }
   
     updateInscription(id: number, inscription: Inscription): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, inscription);
     }
   }
